// extracted by mini-css-extract-plugin
export default {"container":"document_container__307zc","icon":"document_icon__-kvd6","details":"document_details__sAXmc","name":"document_name__So6VS","action":"document_action__PVz35"};